// Client-side friction for sign-in forms. Bots can bypass this, so it complements
// (never replaces) Turnstile and the rate limits configured in Supabase.

const DISPOSABLE_DOMAINS = new Set([
  "mailinator.com", "guerrillamail.com", "guerrillamail.net", "guerrillamail.org",
  "guerrillamailblock.com", "sharklasers.com", "grr.la", "10minutemail.com",
  "10minutemail.net", "tempmail.com", "temp-mail.org", "temp-mail.io", "tempmailo.com",
  "throwawaymail.com", "yopmail.com", "yopmail.net", "trashmail.com", "trashmail.net",
  "getnada.com", "nada.email", "maildrop.cc", "dispostable.com", "fakeinbox.com",
  "mailnesia.com", "mintemail.com", "mohmal.com", "emailondeck.com", "spamgourmet.com",
  "mytemp.email", "burnermail.io", "discard.email", "moakt.com", "tmpmail.org",
  "tmpmail.net", "inboxkitten.com", "mail.tm", "1secmail.com", "1secmail.net",
  "1secmail.org", "dropmail.me", "gmailnator.com", "emailfake.com", "fakemail.net",
  "spam4.me", "mailcatch.com", "tempinbox.com", "tempail.com", "33mail.com",
]);

export function isDisposableEmail(email) {
  const domain = String(email || "").trim().toLowerCase().split("@")[1];
  if (!domain) return false;
  return DISPOSABLE_DOMAINS.has(domain);
}

export const SEND_COOLDOWN_MS = 60_000;

export function secondsUntilNextSend(storageKey) {
  try {
    const last = Number(localStorage.getItem(storageKey));
    if (!last) return 0;
    const remaining = SEND_COOLDOWN_MS - (Date.now() - last);
    return remaining > 0 ? Math.ceil(remaining / 1000) : 0;
  } catch {
    return 0;
  }
}

export function markSent(storageKey) {
  try {
    localStorage.setItem(storageKey, String(Date.now()));
  } catch { /* ignore */ }
}
